import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { useMember } from "@/lib/member";

/**
 * Emergent Google Auth callback.
 * Reads session_id from URL hash, exchanges it with our backend,
 * then navigates to /my-account.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const loc = useLocation();
  const hasProcessed = useRef(false);
  const { setMember } = useMember();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = loc.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post(
          "/members/session",
          {},
          { headers: { "X-Session-ID": sessionId } },
        );
        setMember(data);
        // Clear hash & navigate cleanly
        window.history.replaceState(null, "", "/my-account");
        nav("/my-account", { replace: true, state: { user: data } });
      } catch {
        nav("/?login_failed=1", { replace: true });
      }
    })();
  }, [loc.hash, nav, setMember]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#F7F6FB]">
      <div className="flex flex-col items-center gap-3 text-[#1F2547]">
        <Loader2 className="w-8 h-8 animate-spin text-[#9F87D8]" />
        <div className="font-display font-bold">Signing you in…</div>
      </div>
    </main>
  );
}
